import React, { useState } from "react";
import {
  Box,
  Collapse,
  Typography,
} from "@mui/material";
import expandIcon from "../../../../assets/icons/expandDown.svg";
import shrinkIcon from "../../../../assets/icons/expandUp.svg";
import SelectInput from "../../../../components/SelectInput";

const MyVouchers = ({ options = [], formik }) => {
  const [open, setOpen] = useState(true);

  return (
    <Box
      sx={{
        border: "1px solid rgba(26, 64, 125, 0.1)",
        borderRadius: "16px",
        mb: 2,
        p:3,
      }}
     
    >
      {/* Header with expand/collapse */}
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          cursor: "pointer",
        }}
        onClick={() => setOpen(!open)}
      >
        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
          <Typography
           variant="body2" sx={{ fontWeight: 600 }}
          >
            My Vouchers
          </Typography>
        </Box>
        <img src={open ? shrinkIcon : expandIcon} alt="toggle-icon" />
      </Box>

      {/* Collapsible content */}
      <Collapse in={open}>
        <Box mt={3}>
          <SelectInput
            field={{
              name: "selectedVoucher",
              required: false,
              readonly: false,
              options: options,
              placeholder: "Select",
              showIcon: false,
            }}
            formik={formik}
          />
        </Box>
      </Collapse>
    </Box>
  );
};

export default MyVouchers;
